import { gql } from '@apollo/client';
import { TaxjarCategorySyncRunInfo } from '../fragments';

export default gql`
  query TaxjarCategorySyncRuns($limit: Int) {
    taxjarCategorySyncRuns(limit: $limit) {
      ...TaxjarCategorySyncRunInfo
    }
  }
  ${TaxjarCategorySyncRunInfo}
`;
